import { shouldTrackSearchCount, countSearchFor } from './trackSearchCount'

export const trackSearchResultsDisplay = (currentSite, _location) => {
  if (shouldTrackSearchCount(currentSite)) {
    countSearchFor(currentSite)
  }
}



// WEBPACK FOOTER //
// ./common/utils/tracking/trackSearchResultsDisplay.js